import React, { useState } from "react";

function CupertinoShowHide() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="junk-santa">
        <h3>Comprehensive Junk Removal Services in Cupertino, CA</h3>
        <div className="sliderline-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="4"
            viewBox="0 0 64 4"
            fill="none"
          >
            <path
              d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
              fill="#60BDFF"
            ></path>
          </svg>
        </div>
      </div>

      <div className="junk-santa-desc">
        <p className="yard-desc">
          Junk Droid provides a full range of junk removal Cupertino CA
          services, helping homeowners, small businesses, and commercial
          properties in Cupertino, California and surrounding areas clear out
          unwanted junk. Whether it’s a storage unit, construction debris
          removal, or clearing out a storage unit, our team can handle it all
          with ease. We take pride in offering top-notch junk hauling service
          that includes:
          <ul className="yard-list">
            <li>Furniture Disposal and unwanted furniture removal</li>
            <li>Mattress removal and appliance removal</li>
            <li>Office furniture removal and commercial junk removal</li>
            <li>
              Hazardous waste removal, including electronic waste and e-waste
            </li>
            <li>Yard waste removal, including bulky items and large items</li>
          </ul>
        </p>
      </div>

      {isExpanded && (
        <div>
          <div className="pt-0 junk-santa-desc">
            <h3>Local and Affordable Junk Removal in Cupertino, CA</h3>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <p>
              Serving all of Santa Clara County, Junk Droid is a full-service
              junk removal company that specializes in fast and efficient
              service for both residential and commercial customers. Whether you
              have a single item to remove or need a large-scale cleanout, our
              team is prepared to meet your junk removal needs.
            </p>
          </div>

          <h3>Commercial Junk Removal & Business Services in Cupertino</h3>
          <div className="sliderline-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="4"
              viewBox="0 0 64 4"
              fill="none"
            >
              <path
                d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                fill="#60BDFF"
              ></path>
            </svg>
          </div>

          <div className="junk-santa-desc">
            <p>
              Junk Droid isn’t just for homes. We also cater to business
              services and commercial junk removal. Our team helps offices,
              stores, and industrial sites keep their spaces clear, safe, and
              organized by providing:
            </p>
          </div>

          <h3>Eco-Friendly Practices & Transparent Pricing</h3>
          <div className="sliderline-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="4"
              viewBox="0 0 64 4"
              fill="none"
            >
              <path
                d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                fill="#60BDFF"
              ></path>
            </svg>
          </div>

          <div className="junk-santa-desc">
            <p>
              At Junk Droid, we prioritize eco-friendly practices and the
              environmental impact of our work. We recycle as much as possible,
              donate usable items to local charities, and always ensure that
              hazardous materials are disposed of responsibly. Plus, our
              transparent pricing means you’ll always know the cost upfront.
            </p>
          </div>
          <div className="junk-santa-desc milpitas-list">
            <h3>Serving Cupertino and Surrounding Areas</h3>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <p className="pb-0">
              Junk Droid proudly serves all of Cupertino, including surrounding
              areas such as:
            </p>
            <ul>
              <li>San Jose, CA</li>
              <li>City of Santa Clara</li>
            </ul>
            <p className="pt-0 pb-0">
              Whether you need same-day service or are planning a day junk
              removal, we’re here to help with all your junk removal needs!
            </p>
            <p className="service-description">
              Call Junk Droid today at <a href="+4085397261">(408) 539-7261</a>{" "}
              for your free quote or to schedule a same-day junk removal. Our
              reliable service, professional team, and commitment to
              eco-friendly solutions make us the top choice for junk removal
              Cupertino, junk removal Cupertino CA, and junk removal Cupertino
              California.
            </p>
          </div>
        </div>
      )}

      <button className="btn btn-read" onClick={toggleText}>
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
}

export default CupertinoShowHide;
